import { Typography } from '@mui/material';
import type { FC } from 'react';
import React from 'react';

import Info from '../../UI/Info';
import {
  ActionBox,
  DetailBox,
  Divider,
  HeaderBox,
  MainBox,
  Status,
  StyledButton,
} from './styles';
import type { FixItemProps } from './types';

const FixItem: FC<FixItemProps> = ({
  fixData: { status, createdTime, serialNumber, area, title, content },
  onCheckMore,
  onCheckMessage,
  onCheckProgress,
}) => {
  return (
    <MainBox>
      <HeaderBox>
        <Status $bg={status.color}>{status.text}</Status>
        <Typography
          sx={{
            fontWeight: '500',
            fontSize: '0.9rem',
          }}
        >
          {createdTime}
        </Typography>
      </HeaderBox>
      <DetailBox>
        <Info label="編號" value={serialNumber} />
        <Info label="報修區域" value={area} />
        <Info
          label="標題"
          value={title}
          styles={{
            box: {
              overflow: 'hidden',
            },
            content: {
              maxWidth: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },
          }}
        />
        <Info
          label="內容"
          value={content}
          styles={{
            box: {
              overflow: 'hidden',

              '@media (orientation: landscape)': {
                gridColumn: '1 / 3',
              },
            },
            content: {
              maxWidth: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },
          }}
        />
      </DetailBox>
      <ActionBox>
        <StyledButton onClick={onCheckMore}>查看更多</StyledButton>
        <Divider />
        <StyledButton onClick={onCheckProgress}>查看進度</StyledButton>
        <Divider />
        <StyledButton onClick={onCheckMessage}>即時訊息</StyledButton>
      </ActionBox>
    </MainBox>
  );
};

export default FixItem;
